export function matchesConversationRoom(profile: any, room: any, jobId: string, participantId?: string) {
  if (room?.jobId !== jobId) return false;
  if (!participantId) return true;
  const peer = profile?.participantDetails?.userId || (profile?.groupType === "participant" ? profile.groupId : undefined);
  if (peer) return peer === participantId;
  return room?.participants?.includes(participantId) || false;
}
